import SkeletonLoader from '@/components/SkeletonLoader';

export const SchoolDetailsSkeleton = () => {
  return (
    <div className="w-full bg-white space-y-10 p-0.5">
      {/* school header */}
      <div className="bg-brand-light-50 rounded-2xl p-6 space-y-6">
        <div className="flex gap-2 items-center">
          <div className="flex-1 flex items-center justify-between">
            <div className="flex gap-2 items-center">
              <SkeletonLoader className="h-8 w-8" variant="rect" />
              <SkeletonLoader className="h-6 w-48" variant="text" />
            </div>
            <SkeletonLoader className="h-6 w-16 rounded-full" variant="rect" />
          </div>
        </div>

        <div className="flex justify-between items-center">
          <SkeletonLoader className="h-4 w-24" variant="text" />
          <SkeletonLoader className="h-8 w-40" variant="rect" />
        </div>

        <div className="flex justify-between">
          <SkeletonLoader className="h-4 w-32" variant="text" />
          <SkeletonLoader className="h-4 w-28" variant="text" />
        </div>
      </div>

      {/* stats row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-12">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex items-start gap-3">
            <div className="mt-0.5">
              <SkeletonLoader className="h-5 w-5" variant="rect" />
            </div>
            <div className="flex flex-col gap-1">
              <SkeletonLoader className="h-4 w-24" variant="text" />
              <SkeletonLoader className="h-4 w-12" variant="text" />
            </div>
          </div>
        ))}
      </div>

      {/* teacher summary */}
      <div className="flex flex-col gap-4">
        <div className="flex justify-between items-center">
          <SkeletonLoader className="h-6 w-40" variant="text" />
          <SkeletonLoader className="h-10 w-32" variant="rect" />
        </div>

        <div className="grid grid-cols-3 gap-6">
          {Array.from({ length: 3 }).map((_, i) => (
            <SkeletonLoader key={i} className="h-20 w-full" variant="rect" />
          ))}
        </div>
      </div>

      {/* student summary */}
      <div className="flex flex-col gap-4">
        <div className="flex justify-between items-center">
          <SkeletonLoader className="h-6 w-40" variant="text" />
          <SkeletonLoader className="h-10 w-32" variant="rect" />
        </div>

        <div className="grid grid-cols-3 gap-6">
          {Array.from({ length: 3 }).map((_, i) => (
            <SkeletonLoader key={i} className="h-20 w-full" variant="rect" />
          ))}
        </div>
      </div>
    </div>
  );
};
